import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
  useEffect,
  useRef
} from "react";
import { useSelector } from "react-redux";
import {
  Drawer,
  Button,
  Steps,
  Form,
  Input,
  Radio,
  notification,
  Space,
  Select,
  Alert,
  Upload,
  Tag,
  Typography, Timeline,
  Divider, Tooltip, Menu, Dropdown, Row, Col,
  Spin
} from "antd";
import dayjs from "dayjs";
import { CopyOutlined, MoreOutlined } from "@ant-design/icons";
import documentManagementAPI from '../../../../restAPI/DocumentManagement';
const { Title, Text, Paragraph } = Typography;
const Context = React.createContext({
  name: "Default",
});
const { Step } = Steps;
const { TextArea } = Input;
const onSearch = (value) => {
  console.log("search:", value);
};

const StepForm = forwardRef((props, ref) => {
  console.log("props", props)
  const { open, record, onClose } = props;
  const { token } = useSelector((state) => state.auth);
  const [currentStep, setCurrentStep] = useState(0);
  const [visible, setVisible] = useState(false); // Track drawer visibility
  const [statusTrail, setStatusTrail] = useState([]);
  const [displayedTrail, setDisplayedTrail] = useState([]);
  const [loading, setLoading] = useState(false);
  const { Dragger } = Upload;
  const notificationShown = useRef(false);
  const [attachments, setAttachments] = useState([]);
  const [toEmails, setToEmails] = useState(['buyer@gmail.com']);
  const handleCopyUrl = () => {
    navigator.clipboard.writeText("https://lhdn.gov.my/qr?code=LH");
    notification.success({
      message: 'URL Copied',
      description: 'The URL has been successfully copied to your clipboard.',
      placement: 'topRight', // You can set 'topRight', 'topLeft', 'bottomRight', 'bottomLeft'
    });
  };
  const openNotificationWithIcon = (type, message, description, placement) => {
    // if (!notificationShown.current) {
    notification[type]({
      message: message,
      description: description,
      placement,
    });
    notificationShown.current = true;
    setTimeout(() => {
      notificationShown.current = false;
    }, 5000);
    // }
  };

  useEffect(() => {
    if (token && record && record.documentMoguID) {
      setDisplayedTrail([]);
      getStatusTrailData(token, record);
    }
  }, [token, record]);

  useEffect(() => {
    if (!open) {
      setStatusTrail([]);
      setDisplayedTrail([]);
      setLoading(false);
    }
  }, [open]);

  useEffect(() => {
    if (!statusTrail || statusTrail.length === 0) {
      setDisplayedTrail([]);
      return;
    }

    // Show first item immediately without animation
    setDisplayedTrail([{ ...statusTrail[0], __animate: false }]);

    // If there's only one item, we're done
    if (statusTrail.length === 1) {
      return;
    }

    // Show remaining items one by one with animation
    let index = 1;
    const intervalId = setInterval(() => {
      setDisplayedTrail((prev) => {
        if (index >= statusTrail.length) {
          clearInterval(intervalId);
          return prev;
        }

        const next = [
          ...prev,
          { ...statusTrail[index], __animate: true }
        ];
        index += 1;
        return next;
      });
    }, 420);

    return () => clearInterval(intervalId);
  }, [statusTrail]);

  const getStatusTrailData = async (token, record) => {
    setLoading(true);
    const formData = new FormData();

    formData.append("MOGU_UUID", record?.documentMoguID);
    formData.append("TPS_Id", record?.tPS_Id != undefined ? record?.tPS_Id : "");

    const payload = {
      groupId: localStorage.getItem("groupId"),
      companyId: localStorage.getItem("companyId"),
      MOGU_UUID: record?.documentMoguID,
      TPS_Id: record?.tPS_Id != undefined ? record?.tPS_Id : "",
    };

    await documentManagementAPI.getStatusTrailData(
      token,
      localStorage.getItem("groupId"),
      localStorage.getItem("companyId"),
      formData
    )
      .then((response) => {
        const rows = [];
        if (response.statusTrail && Array.isArray(response.statusTrail)) {
          response.statusTrail.map((rowValue) => {
            rows.push({
              status: rowValue.status,
              reason: rowValue.reason,
              timestamp: rowValue.timestamp,
              changedBy: rowValue?.changedBy
            });
          });
        }
        setStatusTrail(rows);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          openNotificationWithIcon(
            "error",
            "Retrieve Status Trail",
            `${err.response.data.message}`,
            "bottomLeft"
          );
        } else {
          openNotificationWithIcon(
            "error",
            "Retrieve Status Trail",
            `${err.message}`,
            "bottomLeft"
          );
        }
      });
  }

  // Expose methods to the parent component
  useImperativeHandle(ref, () => ({
    openDrawer: () => onClose(true),
    closeDrawer: () => onClose(false)
  }));

  const [api,contextHolder] = notification.useNotification();
  const { Option } = Select;
  const contextValue = useMemo(
    () => ({
      name: "Ant Design",
    }),
    []
  );

  const menu = (
    <Menu>
      <Menu.Item key="1">

        Cancel

      </Menu.Item>
      <Menu.Item key="2">

        Share

      </Menu.Item>
      <Menu.Item key="3">

        PDF Download

      </Menu.Item>
      <Menu.Item key="4">

        Credit Note

      </Menu.Item>
      <Menu.Item key="5">

        Debit Note

      </Menu.Item>
      <Menu.Item key="5">

        Refund Note

      </Menu.Item>
    </Menu>
  );

  const statusColors = {
    uploaded: '#008080',
    pending: '#ffff00',
    extracted: '#FDC483',
    'failed-submittable': '#FCA746',
    submitted: '#1890ff',
    success: '#52c41a',
    failed: '#ff0000',
    deleted: '#888',
    canceled: '#800080',
    'failed-validation': '#008b8b',
    duplicate: '#ff69b4',
    'on hold': '#FF8C00',
    'onhold': '#FF8C00'
  };

  const TimelineComponent = ({ statusTrail, loading }) => {
    if (loading) {
      return (
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <Spin size="large" />
        </div>
      );
    }
    
    if (!statusTrail || statusTrail.length === 0) {
      return (
        <div style={{ padding: '40px', textAlign: 'center' }}>
          <Spin size="large" />
        </div>
      );
    }
    
    return (
    <Timeline
      items={statusTrail.map((item) => ({
        dot: (
          <div
            style={{
              width: '18px',
              height: '18px',
              backgroundColor: statusColors[item.status] || '#888',
              borderRadius: '50%',
              boxShadow: item.__animate ? '0 0 0 6px rgba(24, 144, 255, 0.12)' : '0 0 0 4px rgba(0,0,0,0.08)',
              transition: 'box-shadow 0.4s ease'
            }}
          />
        ),
        children: (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: '15px',
              opacity: item.__animate ? 0 : 1,
              transform: item.__animate ? 'translateY(10px)' : 'translateY(0)',
              animation: item.__animate ? 'fadeInUpSmooth 0.6s cubic-bezier(0.22, 1, 0.36, 1) forwards' : 'none'
            }}
          >
            <div>
              <div style={{ fontSize: '16px', marginBottom: '4px' }}>
                <strong>{item.status.charAt(0).toUpperCase() + item.status.slice(1)}</strong>
              </div>
              <div style={{ fontSize: '14px', color: '#666' }}>
                <div>{dayjs(item.timestamp).format('DD/MM/YYYY HH:mm')}</div>
                {item.changedBy && <div>{item.changedBy}</div>}
                {item.reason && (
                  <div style={{ marginTop: '8px', color: '#888' }}>
                    {item.reason}
                  </div>
                )}
              </div>
            </div>
          </div>
        ),
      }))}
    />
    );
  };

  return (
    <Context.Provider value={contextValue}>
      {contextHolder}
      <style>{`
        @keyframes fadeInUpSmooth {
          0% { opacity: 0; transform: translateY(14px) scale(0.98); }
          60% { opacity: 1; transform: translateY(-2px) scale(1.01); }
          100% { opacity: 1; transform: translateY(0) scale(1); }
        }
      `}</style>
      <Drawer
        open={open}
        onClose={onClose}
        title={
          <div justify="space-between" align="left">
            <span style={{ position: 'relative', top: '5px' }}>Status Trail</span>
          </div>
        }
        width={700}
        footer={
          <div style={{ textAlign: "right" }}>
            <Button style={{ marginRight: 8 }} size="large" onClick={() => onClose(false)}>
              Exit
            </Button>
          </div>
        }
      >
        <div style={{ padding: '20px', minHeight: 200 }}>
          <TimelineComponent statusTrail={displayedTrail} loading={loading} />
        </div>
      </Drawer>
    </Context.Provider>
  );
});

export default StepForm;
